import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { ExternalLink } from '../../../global/components/external-link-modal';
import { WysiwygWithReactLink } from '../../../global/components/wysiwyg-with-react-link';
import { getCurrencyFormat } from '../../../global/helpers/format-helpers';
import { isValueEmpty } from '../../../global/helpers/generic-helper';
import { replaceAll } from '../../../global/helpers/string-helpers';
//import { getCurrencyFormat } from '../../../global/helpers/format-helpers';
//import { isValueEmpty } from '../../../global/helpers/generic-helper';
import { YesNoIndicators } from '../../../global/models/api-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { AnnuityData, MyCpgPodsSettings, MyCpgPodsTypes, PodContent } from '../mycpg-pod-models';
import { PodGridContent } from './pod-grid-content';
import { PodGridContentItem } from './pod-grid-content-item';
import { PodGridItem } from './pod-grid-item';
import { PodGridItemHeader } from './pod-grid-item-header';

export const ID3 = 'ID3';

interface Props {
	settings: MyCpgPodsSettings;
}
export function AnnuityPlanPod(props: Props) {

	const { settings } = props;
	const annuityPlan = useSelector<TcsmStates, AnnuityData>(state => state?.mycpgPodsState?.pods?.annuity_data);
	const filtered = annuityPlan?.data?.filter(a => a !== null);
	const hasPlan = annuityPlan?.content === PodContent.CONTENT && filtered?.length > 0;
	const routeMatch = useRouteMatch();
	const guid = useSelector<TcsmStates, string>(state => state?.authenticatedState.clientGuid);

	if (annuityPlan.show_pod === YesNoIndicators.No) {
		return null;
	}

	const renderPodContent = () => {
		if (annuityPlan?.content === PodContent.NOT_ENROLLED || filtered?.length === 0) {
			return (
				<PodGridContentItem>
					<div dangerouslySetInnerHTML={{ __html: settings?.noAnnuityPlanText }} />
				</PodGridContentItem>
			);
		}

		if (filtered?.length > 1) {

			return (
				<PodGridContentItem>
					<div dangerouslySetInnerHTML={{ __html: settings?.multipleAnnuityPlanText }} />
				</PodGridContentItem>
			);
		}

		if (annuityPlan?.data[0]?.source === ID3) {

			return (
				<>
					{
						!isValueEmpty(annuityPlan?.data[0]?.current_fund_value) &&
						<PodGridContentItem>
							<p className='h3-styled'>{getCurrencyFormat(annuityPlan?.data[0]?.current_fund_value)}</p>
							<p className='grey-caption'>{settings?.currentValueLabel}</p>
						</PodGridContentItem>
					}
					{
						!isValueEmpty(annuityPlan?.data[0]?.surrender_value) &&
						<PodGridContentItem>
							<p className='h3-styled'>{getCurrencyFormat(annuityPlan?.data[0]?.surrender_value)}</p>
							<p className='grey-caption'>{settings?.surrenderValueLabel}</p>
						</PodGridContentItem>
					}
					{
						annuityPlan?.data[0]?.in_distribution &&
						<PodGridContentItem>
							<div dangerouslySetInnerHTML={{ __html: settings.distributionMessage }} />
						</PodGridContentItem>
					}
				</>
			);
		}


		return (
			<>
				<PodGridContentItem>
					{
						settings?.enableFtj ?
							<>
								<p className='h3-styled'>{filtered[0]?.plan_name}</p>
								<p className='grey-caption'>{replaceAll(settings?.policyNumberLabel, '{policy#}', filtered[0]?.policy_id)}</p>
								<p><ExternalLink linkUrl={replaceAll(settings?.annuityPlanFtjRedirect, '{guid}', guid)} linkText={settings?.annuityPlanFtjLinkText} /></p>
							</>
							:
							<WysiwygWithReactLink content={settings?.newAnnuityPodMessage} />
					}
				</PodGridContentItem>
			</>
		);
	};

	return (
		<PodGridItem>
			<PodGridItemHeader title={settings?.annuityPlanTitle}>
				<Link to={`${routeMatch?.path}?type=${MyCpgPodsTypes.ANNUITY}`}>{!hasPlan ? settings?.learnMoreText : settings?.seeMoreLinkText}</Link>
			</PodGridItemHeader>
			<PodGridContent>
				{renderPodContent()}
			</PodGridContent>
		</PodGridItem>
	);

}

